export default "__VITE_ASSET__bbb3c21c__"